/**
 * SettingsInvitationStepEmail form layout script class
 *
 * @package    Layouts
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { Component } from 'react';
import { Field } from 'redux-form';

import { FormEditor } from 'Common/ReduxForm';
import FormGroup from 'Components/FormGroup/FormGroup';
import GridContainer from 'Common/Grid/GridContainer.jsx';
import ItemGrid from 'Common/Grid/ItemGrid.jsx';
import { maxLengthValidation } from 'Utils';
import { CustomFormInput } from 'Common/Form';

const maxLength255 = maxLengthValidation(255);

export default class SettingsInvitationStepEmail extends Component {
    /**
     * Render
     *
     * @returns {*}
     */
    render() {
        return (
            <div>
                <FormGroup required title="form_groups.journal_selection">
                    <Field
                        withLabel
                        rowClassName="mm-form-field"
                        name="subject"
                        component={CustomFormInput}
                        type="text"
                        label="subject"
                        placeholder="subject"
                        validate={[maxLength255]}
                    />

                    <GridContainer>
                        <ItemGrid md={12} className='invitations-email-textarea-wrapper'>
                            <Field
                                withLabel
                                rowClassName="mm-form-field"
                                name="body"
                                component={FormEditor}
                                label="body"
                                placeholder="body"
                            />
                        </ItemGrid>
                    </GridContainer>

                </FormGroup>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/Settings/components/SettingsInvitation/SettingsInvitationStepEmail.jsx